<template>
    <div class="main-container">
        <!-- 内容区 -->
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        methods: {
        },
        mounted() {},
    }
</script>

<style lang="less" scoped>
    .main-container {
        width: 100%;
        height: 100%;
    }
</style>
